export default __webpack_public_path__ + "img/06f8a7184e24c4ac59550d35fbf9b132.png";